import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BlockUIModule } from 'ng-block-ui';
import { AuthGuard } from './shared';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { FrontInterceptor } from './_directives/front.interceptor';
import { GlobalErrorHandler } from './_directives/GlobalErrorHandler.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './_directives/loader/loading.component';
import { ToastModule } from 'src/app/_services/toastr';
import { AlertService } from './_services/alert.service';
import { CustomFormsModule } from 'ngx-custom-validators';
import { AwsS3MappingService } from './_services/aws-s3-mapping.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Ng2SearchPipeModule } from 'node_modules/ng2-search-filter';
import { LoadingService } from 'src/app/_services/loading.service';
import { VASProductMgmtService } from 'src/app/_services/vasprodmgmt.service';
import { ConfigService } from './_services/config.service';
import { APP_INITIALIZER } from '@angular/core';
//import {NgxPaginationModule} from 'ngx-pagination';

const appInitializerFn = (configService: ConfigService) => {
  return () => {
    return configService.setConfig();
  };
};

@NgModule({
  declarations: [
    AppComponent,
    LoadingComponent
  ],
  imports: [
    Ng2SearchPipeModule,
    //NgxPaginationModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BlockUIModule.forRoot(),
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    ToastModule.forRoot(),
    CustomFormsModule
  ],

  providers: [AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FrontInterceptor,
      multi: true
    }, {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    }, AlertService,AwsS3MappingService,VASProductMgmtService,
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [ConfigService]
    }],
  bootstrap: [AppComponent,]
})
export class AppModule { }
